import React from "react";

const NewChatIcon = () => {
  return (
    <div>
      <svg
        fill="#000000"
        height="24"
        width="24"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 492.308 492.308"
      >
        <g>
          <g>
            <polygon
              points="256,179.995 256,91.664 236.308,91.664 236.308,179.995 147.971,179.995 147.971,199.688 236.308,199.688 
			236.308,288.024 256,288.024 256,199.688 344.337,199.688 344.337,179.995 		"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M443.077,16.947H49.231C22.087,16.947,0,39.034,0,66.178V330.25c0,27.144,22.087,49.231,49.231,49.231h63.889l0.846,95.88
			l107.986-95.88h221.125c27.144,0,49.231-22.087,49.231-49.231V66.178C492.308,39.034,470.221,16.947,443.077,16.947z
			 M472.615,330.25c0,16.288-13.25,29.538-29.538,29.538H214.471l-81.197,72.091l-0.635-72.091H49.231
			c-16.288,0-29.538-13.25-29.538-29.538V66.178c0-16.288,13.25-29.538,29.538-29.538h393.846c16.288,0,29.538,13.25,29.538,29.538
			V330.25z"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default NewChatIcon;
